<template>
  <v-chip class="sentiment mr-3" dark color="tertiary" disabled  mb-0>{{sentimentLabel}}</v-chip>
</template>

<script>
export default {
  name: "SentimentPill",
  props: {
    sentimentScore: {
      type: Number,
      required: true
    },
    sentimentMagnitude: {
      type: Number,
      required: true
    }
  },
  computed: {
    sentimentLabel() {
      if (this.sentimentScore >= 0.75) {
        return "Very Happy"
      } else if (this.sentimentScore >= 0.25 && this.sentimentScore < 0.75) {
        return "Happy"
      } else if (this.sentimentScore >= 0 && this.sentimentScore < 0.25) {
        return "Neutral"
      } else if (this.sentimentScore >= -0.5 && this.sentimentScore < 0) {
        return "Unhappy"
      } else {
        return "Very Unhappy"
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sentiment {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>